export enum TransactionsRouteName {
    Transactions = 'transactions'
}
